import { Button, CardActions, TextField, Typography } from "@mui/material";
import Container from "@mui/material/Container";
import Card from "@mui/material/Card";
import { ReactComponent as Logo } from "../assets/logo.svg";
import CardContent from "@mui/material/CardContent";
import { useForm } from "react-hook-form";
import { createUserSchema } from "../schemas";
import { useAuth } from "../providers/users";
import { yupResolver } from "@hookform/resolvers/yup";
import { useHistory } from "react-router-dom";

const SignupForm = () => {
  const history = useHistory();
  const { signUp } = useAuth();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({ resolver: yupResolver(createUserSchema) });

  function onLogin(payload) {
    signUp(payload);
    reset();
  }
  return (
    <>
      <Container
        maxWidth="lg"
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row-reverse" },
          mb: "2rem",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Container
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            alignItems: "center",
            justifyContent: "center",
            mb: "2rem",
          }}
        >
          <Typography
            sx={{
              fontSize: { xs: "4rem", md: "8rem" },
              fontWeight: "bold",
              color: "accent.light",
            }}
            color="accent.light"
            align="center"
            fontWeight={800}
          >
            Anthorflix
          </Typography>
          <Logo style={{ maxWidth: "100px", maxHeight: "100px" }} />
        </Container>
        <form onSubmit={handleSubmit(onLogin)}>
          <Card
            sx={{
              width: { xs: "90vw", md: "35vw", lg: "30vw" },
              height: "75vh",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "space-between",
              backgroundColor: "background.main",
            }}
            elevation={4}
          >
            <CardContent
              sx={{
                display: "flex",
                flexDirection: "column",
                width: "85%",
                flexGrow: 4.5,
                justifyContent: "space-around",
              }}
            >
              <Typography
                sx={{
                  fontWeight: 700,
                  fontSize: "2.5rem",
                  color: "primary.dark",
                  display: "flex",
                  alignItems: "center",
                }}
                component="div"
                gutterBottom
              >
                Faça seu cadastro
                <Typography
                  sx={{
                    fontWeight: 700,
                    fontSize: "5rem",
                    color: "accent.dark",
                  }}
                >
                  (:
                </Typography>
              </Typography>

              <TextField
                label="Nome"
                placeholder="Digite seu nome completo"
                fullWidth
                {...register("name")}
                error={!!errors.name}
                helperText={errors.name?.message}
                size="small"
              />
              <TextField
                label="E-mail"
                placeholder="Digite seu e-mail"
                fullWidth
                {...register("email")}
                error={!!errors.email}
                helperText={errors.email?.message}
                size="small"
              />
              <TextField
                label="Senha"
                placeholder="Digite sua senha"
                type="password"
                {...register("password")}
                error={!!errors.password}
                helperText={errors.password?.message}
                size="small"
              />
              <TextField
                label="Confirmação de senha"
                placeholder="Digite sua senha novamente"
                type="password"
                {...register("confirmPassword")}
                error={!!errors.confirmPassword}
                helperText={errors.confirmPassword?.message}
                size="small"
              />
            </CardContent>
            <CardActions
              sx={{
                flexGrow: 0.5,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Button variant="contained" color="primary" type="submit">
                CADASTRAR
              </Button>
              <Button color="primary" onClick={() => history.push("/")}>
                ENTRAR
              </Button>
            </CardActions>
          </Card>
        </form>
      </Container>
    </>
  );
};

export default SignupForm;
